export enum Sorting {
    RELEVANCE = 'relevance',
    NAME_ASC = 'name_asc',
    NAME_DESC = 'name_desc',
    SCORE_ASC = 'score_asc',
    SCORE_DESC = 'score_desc',
    DATE_ASC = 'date_asc',
    DATE_DESC = 'date_desc',
    INGREDIENT_PROPORTION_ASC = 'ingredient_proportion_asc',
    INGREDIENT_PROPORTION_DESC = 'ingredient_proportion_desc'
}